import React, { useState } from "react";
import useFetch from "../../../../hooks/useAxios";
import SpecialistWage from "./SpecialistWage";
import WageForAllRes from "./WageModal.js/WageForAllRes";
import WageForCodeRes from "./WageModal.js/WageForCodeRes";
import WageForTypeRes from "./WageModal.js/WageForTypeRes";
import WageTypes from "./WageTypes";
import WebsiteWage from "./WebsiteWage";

const AdminWage = () => {
  const [GeneralWage, setGeneralWage] = useState(false);
  const [CodeWage, setCodeWage] = useState(false);
  const [CodeWageMessage, setCodeWageMessage] = useState();
  const [CodeWageEdit, setCodeWageEdit] = useState(false);
  const [TypeWage, setTypeWage] = useState(false);
  const [TypeWageEdit, setTypeWageEdit] = useState(false);
  const [TypeWageMessage, setTypeWageMessage] = useState(false);
  const [WageList, setWageList] = useState();
  const apiWageList = useFetch({
    method: "get",
    url: "api/admin/wages",
    noHeader: false,
    trigger: true,
    argFunc: res => setWageList(res.data)
  });
  console.log(CodeWageEdit);
  return (
    <div>
      {WageList &&
        <div>
          <WebsiteWage setCodeWage={setCodeWage}  setTypeWage={setTypeWage}  apiWageList={apiWageList} setGeneralWage={setGeneralWage} WageList={WageList} />
          <WageTypes apiWageList={apiWageList} setTypeWageMessage={setTypeWageMessage}  setTypeWageEdit={setTypeWageEdit}  WageList={WageList} />
          <SpecialistWage apiWageList={apiWageList} setCodeWageEdit={setCodeWageEdit}  setCodeWageMessage={setCodeWageMessage} WageList={WageList} />
        </div>}
        {GeneralWage &&  <WageForAllRes  apiWageList={apiWageList} closeModal={()=>setGeneralWage(false)} />}
     {CodeWage && <WageForCodeRes info={CodeWageMessage} apiWageList={apiWageList} closeModal={()=>setCodeWage(false)} />}
     {CodeWageEdit && <WageForCodeRes info={CodeWageMessage} edit={CodeWageEdit} apiWageList={apiWageList} closeModal={()=>setCodeWageEdit(false)} />}
    {TypeWage &&  <WageForTypeRes apiWageList={apiWageList} closeModal={()=>setTypeWage(false)}/>}
    {TypeWageEdit &&  <WageForTypeRes info={TypeWageMessage} edit={TypeWageEdit} apiWageList={apiWageList} closeModal={()=>setTypeWageEdit(false)}/>}
    </div>
  );
};

export default AdminWage;
